import React from 'react'
import { Dialog, ScrollBar } from 'components/ui'
import { useHelp } from 'contexts/HelpContext'
import { getHelpContent } from 'configs/guide.config'
import { HiOutlineLightBulb, HiOutlineExclamation } from 'react-icons/hi'

const HelpModal = () => {
    const { isHelpOpen, currentPageKey, closeHelp } = useHelp()
    const helpContent = getHelpContent(currentPageKey)

    if (!helpContent) {
        return null
    }

    return (
        <Dialog
            isOpen={isHelpOpen}
            onClose={closeHelp}
            onRequestClose={closeHelp}
            width={800}
        >
            <div className="flex flex-col max-h-[80vh]">
                {/* Header */}
                <h4 className="mb-4">{helpContent.title}</h4>

                {/* Video Section */}
                {helpContent.videoUrl && (
                    <div className="aspect-video mb-4 rounded-lg overflow-hidden bg-gray-100">
                        <iframe
                            src={helpContent.videoUrl}
                            className="w-full h-full"
                            title={helpContent.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                )}

                {/* Content Section */}
                <ScrollBar className="flex-1 overflow-y-auto pr-2">
                    {/* Introduction */}
                    {helpContent.introduction && (
                        <p className="text-gray-600 mb-4">
                            {helpContent.introduction}
                        </p>
                    )}

                    {/* Steps */}
                    {helpContent.steps && helpContent.steps.length > 0 && (
                        <div className="mb-4">
                            <h5 className="mb-3">Etapes</h5>
                            <ol className="list-decimal list-inside space-y-3">
                                {helpContent.steps.map((step, index) => (
                                    <li key={index} className="text-gray-700">
                                        <span className="font-medium">
                                            {step.title}
                                        </span>
                                        {step.content && (
                                            <p className="mt-1 ml-5 text-gray-600">
                                                {step.content}
                                            </p>
                                        )}
                                    </li>
                                ))}
                            </ol>
                        </div>
                    )}

                    {/* Tips */}
                    {helpContent.tips && helpContent.tips.length > 0 && (
                        <div className="mb-4 p-3 bg-blue-50 rounded-lg">
                            <div className="flex items-center gap-2 mb-2">
                                <HiOutlineLightBulb className="text-blue-500 text-xl" />
                                <h6 className="text-blue-700">Conseils</h6>
                            </div>
                            <ul className="list-disc list-inside space-y-1 text-blue-700">
                                {helpContent.tips.map((tip, index) => (
                                    <li key={index}>{tip}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Warnings */}
                    {helpContent.warnings && helpContent.warnings.length > 0 && (
                        <div className="mb-4 p-3 bg-amber-50 rounded-lg">
                            <div className="flex items-center gap-2 mb-2">
                                <HiOutlineExclamation className="text-amber-500 text-xl" />
                                <h6 className="text-amber-700">Attention</h6>
                            </div>
                            <ul className="list-disc list-inside space-y-1 text-amber-700">
                                {helpContent.warnings.map((warning, index) => (
                                    <li key={index}>{warning}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </ScrollBar>
            </div>
        </Dialog>
    )
}

export default HelpModal
